module.exports = __webpack_public_path__ + "img/p-train.ef3951af.png";